import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
  quote: {},
  quotes: [],
}

export const fetchQuotes = createAsyncThunk("quotes/fetchQuotes", async () => {
  try {
    const token = window.localStorage.getItem("token")
    const response = await axios.get("/api/quote", {
      headers: {
        Authorization: token,
      },
    })
    return response.data
  } catch (err) {
    console.error("Error fetching quotes:", err)
    throw err
  }
})

export const fetchQuote = createAsyncThunk("quotes/fetchQuote", async (id) => {
  try {
    const token = window.localStorage.getItem("token")
    const response = await axios.get(`/api/quote/${id}`, {
      headers: {
        Authorization: token,
      },
    })
    return response.data
  } catch (err) {
    console.error("Error fetching quote:", err)
    throw err
  }
})

export const createQuote = createAsyncThunk(
  "quotes/createQuote",
  async (quoteData) => {
    try {
      console.log("Creating quote with data:", quoteData)

      const token = window.localStorage.getItem("token")
      const response = await axios.post("/api/quote", quoteData, {
        headers: {
          Authorization: token,
        },
      })
      return response.data
    } catch (err) {
      console.error("Error creating quote:", err)
      throw err
    }
  }
)

export const updateQuote = createAsyncThunk(
  "quotes/updateQuote",
  async ({ id, updatedData }) => {
    try {
      const token = window.localStorage.getItem("token")
      const response = await axios.put(`/api/quote/${id}`, updatedData, {
        headers: {
          Authorization: token,
        },
      })
      return response.data
    } catch (err) {
      console.error("Error updating quote:", err)
      throw err
    }
  }
)

export const deleteQuote = createAsyncThunk(
  "quotes/deleteQuote",
  async (id) => {
    try {
      const token = window.localStorage.getItem("token")
      await axios.delete(`/api/quote/${id}`, {
        headers: {
          Authorization: token,
        },
      })
      return id
    } catch (err) {
      console.error("Error deleting quote:", err)
      throw err
    }
  }
)

const quotesSlice = createSlice({
  name: "quotes",
  initialState,
  reducers: {
    setQuote: (state, action) => {
      state.quote = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchQuotes.fulfilled, (state, action) => {
      return { ...state, quotes: action.payload }
    })
    builder.addCase(fetchQuote.fulfilled, (state, action) => {
      return { ...state, quote: action.payload }
    })
    builder.addCase(createQuote.fulfilled, (state, action) => {
      state.quotes.push(action.payload)
    })
    builder.addCase(updateQuote.fulfilled, (state, action) => {
      state.quotes = state.quotes.map((quote) =>
        quote.id === action.payload.id ? action.payload : quote
      )
    })
    builder.addCase(deleteQuote.fulfilled, (state, action) => {
      state.quotes = state.quotes.filter((quote) => quote.id !== action.payload)
    })
  },
})

export const { setQuote } = quotesSlice.actions
export default quotesSlice.reducer
